<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
        <vs-prompt
            :title="$t('NewContact')"
            :accept-text="$t('Save')"
            :cancel-text="$t('Cancel')"
            @cancel="clearContactModal"
            @accept="SaveContact"
            @close="clearContactModal"
            :is-valid="isFormValid"
            :active.sync="activePrompt">
                <VuePerfectScrollbar style="height: 372px!important" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent style="max-height:75vh">
                        <label for="Contact Type" class="vs-input--label">{{$t('ContactType')}}</label>
                                  <v-select
                                    label="Name"
                                    class="mt-5 w-full"
                                    v-model="contact.ContactType"
                                    :options="contactTypes"
                                    :reduce="ContactType => ContactType"
                                   @input="checkEmailType"
                                  />


                      <vs-input class="w-full mt-4" :label="$t('ContactText')" v-if="isMail" v-validate="'required|email|min:3'" v-model="contact.ContactText" name="ContactText" />
                     <vs-input class="w-full mt-4" :label="$t('ContactText')" v-if="!isMail"  v-model="contact.ContactText" name="ContactText" />
                       <span class="text-danger text-sm"  v-show="errors.has('ContactText')">{{ errors.first('ContactText') }}</span>
                    </form>
                </VuePerfectScrollbar>
          </vs-prompt>

   <div>
    <div class="vx-row">

<div  class="vx-col lg:w-4/4 w-full">
      <vx-card :title="$t('Contact')" class="mb-base" >
          <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus" @click="activePrompt=true">{{$t('AddContact')}} </vs-button>

          <vs-table ref="table"   pagination :max-items="5"  :data="getListOfInstructorContact" >
            <template slot="thead">
              <vs-th >{{$t('ContactType')}}</vs-th>
              <vs-th >{{$t('ContactText')}}</vs-th>
              <vs-th>{{$t('Action')}}</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                       <p class="product-name font-medium truncate">{{ tr.ContactType.Name }}</p>
                    </vs-td>
                  <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.ContactText }}</p>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editContact(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
      </vx-card>
</div>
</div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleContactType from "@/store/settings/contactType/moduleContactType.js";
export default {
   components: {

     vSelect,
     VuePerfectScrollbar
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
       activePrompt:false,
      instructorModel: this.data,
       settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      isMail:false,
      contact:{},
       dataForDeleted:{},
      edit:false,
      listOfInstructorContact:[],
    }
  },
  computed: {
    isFormValid() {
      debugger;
      return !this.errors.any() && this.contact.ContactType!=undefined && this.contact.ContactText!=undefined;
    },
    getListOfInstructorContact(){
      return this.instructorModel.InstructorContacts
    },
    contactTypes() {
      return this.$store.state.contactTypeList.contactTypes;
    }
  },
  methods: {
    checkEmailType(){
       if(this.contact.ContactType!=undefined){
         if(this.contact.ContactType.ID==4){
           this.isMail=true;
         }
         else{
           this.isMail=false;
         }
       }
    },
    SaveContact()
    {
        debugger;
        const isExist = this.instructorModel.InstructorContacts.findIndex((p) => p.ContactTypeID == this.contact.ContactType.ID);

        if(isExist>=0)
        {
          if(this.edit)
          {
            if(this.dataForDeleted.ContactType.ID!=this.contact.ContactType.ID)
            {
              this.$vs.dialog({
                color: "warning",
                title:this.$t("Dialogwarning") ,
                text: this.$t("ThisContactAlreadyExists"),
            })
            this.contact={};
            return;
            }
          }
         // this.colorAlert = color
            else{
              this.$vs.dialog({
                color: "warning",
                title: this.$t("Dialogwarning"),
               text: this.$t("ThisContactAlreadyExists"),

            })
            this.contact={};
            return;
            }
        }
        if(this.edit)
          {
              this.deleteContact(this.dataForDeleted);
              this.edit=false;
          }
          this.contact.ContactTypeID=this.contact.ContactType.ID;
          //this.deleteContact(this.contact);
          this.listOfInstructorContact.push(this.contact);
         this.instructorModel.InstructorContacts=this.listOfInstructorContact;
          //this.deletefacility(this.facility);
         // this.$store.commit("classRoomList/ADD_Facility", this.facility);
          this.clearContactModal();
    },

     clearContactModal() {
      this.contact = {}
    },



    openConfirm(data) {
      debugger;
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord")+"?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
    debugger;
      this.deleteContact(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
          text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteContact(data) {
      debugger;
      if(data.ID>0)
      {
         this.$store.dispatch("instructorList/removeContact",  data.ID);
      }
      debugger;
    const ItemIndex = this.instructorModel.InstructorContacts.findIndex((p) => p.ContactTypeID == data.ContactTypeID)
      //if(ItemIndex!=-1)
          this.instructorModel.InstructorContacts.splice(ItemIndex, 1)
    },
    editContact(data){
    this.edit=true;
       this.contact = JSON.parse(JSON.stringify(data));
       this.dataForDeleted=JSON.parse(JSON.stringify(data));
       this.activePrompt=true;

    },
  },

  created(){
    debugger;
    if (!moduleContactType.isRegistered) {
      this.$store.registerModule("contactTypeList", moduleContactType);
      moduleContactType.isRegistered = true;
    }
    this.$store.dispatch("contactTypeList/fetchDataListItems");
    if(this.instructorModel.InstructorContacts.length>0)
    {
     this.listOfInstructorContact= this.instructorModel.InstructorContacts;
    }
  }
}
</script>
